var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeachVolley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.3,
    cy: 81,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9,92.6c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9C138.9,96.6,134.8,92.6,129.9,92.6z M129.9,107.9c-3.5,0-6.3-2.8-6.3-6.3 c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3C136.1,105,133.3,107.9,129.9,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2,114.5L94.7,84.9c-1.8-1.8-4.1-2.6-6.4-2.6H59.2l0,23.1H80l16.5,16.5c0.9,0.9,2.2,1.5,3.6,1.5h20.6 c2.8,0,5.1-2.3,5.1-5.1C125.9,116.8,125.3,115.5,124.2,114.5z M102.3,113.1l-7.7-7.7h6l7.7,7.7H102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,42c-2-2-5.3-2-7.3,0c-2,2-2,5.3,0,7.3l17.9,17.9v33.2c0,2.8,2.3,5.1,5.1,5.1H54V82.3L13.7,42z M34.6,95.1V77.4 l17.7,17.7H34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,134.9L5.5,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C6.9,135.5,6.3,134.9,5.5,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9,134.9L49.9,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C51.2,135.5,50.6,134.9,49.9,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1,134.9L11.1,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C12.4,135.5,11.8,134.9,11.1,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4,134.9L55.4,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C56.8,135.5,56.1,134.9,55.4,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5,134.9L66.5,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C67.8,135.5,67.2,134.9,66.5,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2,134.9L33.2,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C34.6,135.5,34,134.9,33.2,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7,134.9L27.7,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C29.1,135.5,28.5,134.9,27.7,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3,134.9L44.3,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C45.7,135.5,45.1,134.9,44.3,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,134.9L22.2,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C23.5,135.5,22.9,134.9,22.2,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6,134.9L16.6,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C18,135.5,17.4,134.9,16.6,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,134.9L38.8,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C40.1,135.5,39.5,134.9,38.8,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9,134.9L60.9,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C62.3,135.5,61.7,134.9,60.9,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,134.9L121.9,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C123.2,135.5,122.6,134.9,121.9,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4,134.9L127.4,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C128.8,135.5,128.1,134.9,127.4,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.8,134.9L110.8,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C112.1,135.5,111.5,134.9,110.8,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.3,134.9L116.3,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C117.7,135.5,117.1,134.9,116.3,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,134.9L132.9,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C134.3,135.5,133.7,134.9,132.9,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.5,134.9L138.5,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C139.8,135.5,139.2,134.9,138.5,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1,134.9L83.1,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C84.4,135.5,83.8,134.9,83.1,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2,134.9L105.2,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C106.6,135.5,106,134.9,105.2,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,134.9L72,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4C73.4,135.5,72.8,134.9,72,134.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,134.9L77.5,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C78.9,135.5,78.3,134.9,77.5,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6,134.9L88.6,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C90,135.5,89.4,134.9,88.6,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2,134.9L94.2,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C95.5,135.5,94.9,134.9,94.2,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,134.9L99.7,134.9c-0.8,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0c0.7,0,1.4-0.6,1.4-1.4 C101.1,135.5,100.5,134.9,99.7,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,134.9c-0.7,0-1.4,0.6-1.4,1.4c0,0.7,0.6,1.4,1.4,1.4h0L144,134.9C144,134.9,144,134.9,144,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,134.9v2.7l0,0c0.7,0,1.4-0.6,1.4-1.4C1.4,135.5,0.7,134.9,0,134.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeachVolley);
export default __webpack_public_path__ + "static/media/beachVolley.f3e0e54cec489dc8c21d85770bdc079c.svg";
export { ForwardRef as ReactComponent };